export * from './add-royalties/add-royalties.dialog';
export * from './create-account/create-account.dialog';
